module.exports = __webpack_public_path__ + "img/PositionManagement.e9b6bff2.png";